import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'

import { ToolsSuggestionArticles } from 'components/molecules/toolsSuggestionArticles'

export const StyledBabyGrowthPage = styled.div`
  .health-tool-review {
    width: 150px;
  }

  ${MediaQueries.mbUp} {
    .description {
      width: 100%;
      max-width: 648px;
    }
    .health-tool-review {
      width: 100%;
    }
  }
`

export const StyledToolsSuggestionArticles = styled(ToolsSuggestionArticles)`
  ${MediaQueries.mbDown} {
    & > div {
      background-color: #ffffff !important;
      padding-inline: 0 !important;
      padding-top: 0 !important;
      padding-bottom: 8px !important;
      div {
        background-color: #ffffff !important;
      }
      & > div:first-child {
        padding-top: 0;
      }
    }

    .hhg-page-container {
      padding-left: 0;
      padding-right: 0;
    }
  }
`
